export default {
  leaveEmployees: (params) => {
    if (params && Object.keys(params).length) {
      return `hrmis/leave_employee?${setParams(params)}`;
    }
    return `hrmis/leave_employee`;
  },
  handoverLeaveEmployees: (params) => {
    if (params && Object.keys(params).length) {
      return `hrmis/handover/employee?${setParams(params)}`;
    }
    return `hrmis/handover/employee`;
  },
  employee: (no) => `hrmis/employee?no=${no}`,
  getJobDescription: "cu/hrmis_cu/getJDreport",
  profilePicture: "cu/hrmis_cu/getEmployeePicture",
  jobs: "hrmis/job",
  TRAINING_PROGRAMMES: `training/training_programmes`,
  trainees: `training/trainees`,
  taskSetup: "projects/setups/taskSetup",
  activitiesSetup: "projects/setups/activitiesSetup",
};

const setParams = (params) => {
  let str = "";
  for (const key in params) {
    if (params[key]) {
      str += `${key}=${params[key]}&`;
    }
  }
  return str.slice(0, -1);
};
